import { IonContent, IonPage, IonRadio, IonRadioGroup, IonText, useIonToast } from '@ionic/react'
import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { CustomSpacer, FooterButtons, StyleIonHeader, StyleIonInputNew, TextStyle } from '../../../../components'
import 'swiper/css'
import 'swiper/css/pagination'
import { DivideLine, DivideLineBold } from '../../../../components/atoms/divide'
import { checkbox } from 'ionicons/icons'
import { StoresContext } from '../../../../provider/StoreProvider'
import { CANCEL_TYPE, isLoaded, VALIDATE_STATUS_TRADE } from '../../../../common'

type Props = {
  onDismiss: () => void
  propsValues: { productId: number; count: number; remainCount: number; cost: number; type: 'SELL' | 'BUY'; id: number }
}

export const TradeCancelModal: React.FC<Props> = ({ onDismiss, propsValues }) => {
  const [presentToast] = useIonToast()
  const { marketStore } = useContext(StoresContext)
  const [cancelResult, setCancelResult] = useState<boolean | null>(null)
  const [cancelType, setCancelType] = useState<CANCEL_TYPE>(CANCEL_TYPE.CANCEL)
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS_TRADE>(VALIDATE_STATUS_TRADE.INPUT)
  const [inputValues, setInputValues] = useState({
    count: 0,
  })
  const { count } = inputValues
  const yetPagingStore = marketStore.tradeHistoryYetPagingStore

  const onCancelTypeChange = (cancelType: CANCEL_TYPE) => {
    setCancelType(CANCEL_TYPE[cancelType])
  }

  const onChangeInput = (event: { target: { value: string | number; name: string | number } }) => {
    const { value, name } = event.target
    setInputValues({ ...inputValues, [name]: value })
  }

  const validate = () => {
    if (cancelType === CANCEL_TYPE.CANCEL) {
      setValidateStatus(VALIDATE_STATUS_TRADE.CANCEL)
    }
    if (cancelType === CANCEL_TYPE.PARTIAL_CANCEL) {
      if (count <= 0) {
        setValidateStatus(VALIDATE_STATUS_TRADE.INPUT)
      } else if (count > propsValues.remainCount) {
        setValidateStatus(VALIDATE_STATUS_TRADE.COUNT)
      } else {
        setValidateStatus(VALIDATE_STATUS_TRADE.CANCEL)
      }
    }
  }

  useEffect(() => {
    validate()
  }, [cancelType, count])

  const onCancelTrade = async () => {
    if (isLoaded(marketStore.productDetail)) {
      if (cancelType === CANCEL_TYPE.CANCEL) {
        const result = await marketStore.cancelTrade(
          marketStore.productDetail?.id,
          propsValues.id,
          propsValues.remainCount,
        )
        await yetPagingStore.load({ param: { productId: Number(marketStore.productDetail?.id) } }, true)
        if (result != null) {
          await setCancelResult(result)
        }
        return
      }
      if (cancelType === CANCEL_TYPE.PARTIAL_CANCEL) {
        const result = await marketStore.cancelTrade(marketStore.productDetail?.id, propsValues.id, count)
        await yetPagingStore.load({ param: { productId: Number(marketStore.productDetail?.id) } }, true)

        if (result != null) {
          await setCancelResult(result)
        }
        return
      }
    } else {
      return
    }
  }

  useEffect(() => {
    if (cancelResult == null) {
      return
    }
    if (cancelResult) {
      presentToast({
        message: '거래가 취소되었습니다.',
        duration: 3000,
        position: 'top',
        color: 'primary',
        icon: checkbox,
      })
      onDismiss()
    }
    if (!cancelResult) {
      presentToast({
        message: '거래 취소에 실패했습니다!',
        duration: 3000,
        position: 'top',
        color: 'danger',
        icon: checkbox,
      })
    }
  })
  return (
    <IonPage>
      <StyleIonHeader type={'MODAL'} title={'미체결 거래 취소'} onDismiss={onDismiss} />
      <IonContent>
        <ProductContainer>
          {isLoaded(marketStore.productDetail) && (
            <ProductInfoContainer>
              <img
                src={marketStore.productDetail?.imageUri}
                alt={marketStore.productDetail?.name}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = '/img/thumbnail.svg'
                }}
              />
              <div className="product-info">
                <IonText className="artist">{marketStore.productDetail?.artist}</IonText>
                <IonText className="title">{marketStore.productDetail?.name}</IonText>
              </div>
            </ProductInfoContainer>
          )}
        </ProductContainer>
        <DivideLineBold />
        <SectionContainer>
          <TextStyle type={'b_16'}>{`${propsValues.type === 'BUY' ? '구매' : '판매'} 취소`}</TextStyle>
          <CustomSpacer spacing="16px" />
          <ContentContainer>
            <div style={{ width: '100px', display: 'flex' }}>
              <StyleIonRadio value={cancelType} onIonChange={(e) => onCancelTypeChange(e.detail.value)}>
                <RadioWrap>
                  <IonRadio aria-label="radio" value="CANCEL"></IonRadio>
                  <CustomSpacer spacing="24px" />
                  <IonRadio aria-label="radio" value="PARTIAL_CANCEL"></IonRadio>
                </RadioWrap>
              </StyleIonRadio>
              <IndexContainer>
                <TextStyle type={'r_13'}>전체 취소</TextStyle>
                <CustomSpacer spacing="20px" />
                <TextStyle type={'r_13'}>일부 취소</TextStyle>
              </IndexContainer>
            </div>
            <InputWrap>
              <BetweenWrap>
                <TextStyle type={'b_15'}></TextStyle>
                <TextStyle type={'b_15'}>{propsValues.remainCount.toLocaleString()} 개</TextStyle>
              </BetweenWrap>
              <CustomSpacer spacing="10px" />
              <BetweenWrap>
                <StyleIonInputNew
                  isRightText={true}
                  type={'number'}
                  inputType={'INPUT'}
                  inputStyle={'BOX'}
                  placeholder="수량을 입력해주세요"
                  onInput={onChangeInput}
                  name={'count'}
                  disabled={cancelType === CANCEL_TYPE.CANCEL ? true : false}
                />
                <div className="text_wrap_right">
                  <TextStyle type={'b_15'}>개</TextStyle>
                </div>
              </BetweenWrap>
            </InputWrap>
          </ContentContainer>
          <DivideWrap>
            <DivideLine />
          </DivideWrap>
          <BetweenWrap>
            <TextStyle type={'b_16'}>{`${propsValues.type === 'BUY' ? '구매' : '판매'} 취소 금액`}</TextStyle>
            {cancelType === CANCEL_TYPE.CANCEL ? (
              <TextStyle type={'b_16'}>{`${Math.floor(
                propsValues.cost * propsValues.remainCount * 1.011,
              ).toLocaleString('ko-Kr')} 원`}</TextStyle>
            ) : (
              <TextStyle type={'b_16'}>{`${Math.floor(propsValues.cost * count * 1.011).toLocaleString(
                'ko-Kr',
              )} 원`}</TextStyle>
            )}
          </BetweenWrap>
          <TextStyle type={'m_13'}>(미체결 금액에 포함되었던 수수료가 취소됩니다.)</TextStyle>
        </SectionContainer>
      </IonContent>
      <FooterButtons
        button={{
          color: propsValues.type === 'BUY' ? 'primary' : 'danger',
          disabled: validateStatus === VALIDATE_STATUS_TRADE.CANCEL ? false : true,
          text: propsValues.type === 'BUY' ? `구매 ${validateStatus}` : `판매 ${validateStatus}`,
          onClick: onCancelTrade,
        }}
      />
    </IonPage>
  )
}

const ProductContainer = styled.div`
  padding: 24px 20px;
`

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  img {
    border-radius: 7px;
    min-width: 80px;
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
  .product-info {
    grid-area: 1 / 1 / 2 / 5;
    display: flex;
    flex-direction: column;
    font-size: 15px;
    .artist {
      white-space: nowrap;
      color: var(--ion-color-primary_light);
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      font-size: 16px;
      font-weight: 700;
    }
  }
`

const SectionContainer = styled.div`
  padding: 24px 20px;
`

const StyleIonRadio = styled(IonRadioGroup)`
  margin-top: 4px;
  ion-radio {
    width: 18px;
    height: 18px;
  }

  ion-radio::part(container) {
    border-radius: 10px;
    border: 2px solid #ddd;
  }

  ion-radio::part(mark) {
    background-color: #ffffff;
  }

  ion-radio.radio-checked::part(container) {
    background: var(--ion-color-primary_dark);
    border-color: transparent;
  }

  ion-radio.radio-checked::part(mark) {
    width: 8px;
    height: 8px;
    border-color: #fff;
  }
`

const RadioWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
`
const IndexContainer = styled.div`
  width: 70px;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 107px;
`

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const BetweenWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left_items {
    display: flex;
    align-items: center;
    ion-icon {
      margin-left: 6px;
    }
  }
  .text_wrap_left {
    width: 80px;
    margin: auto 0;
  }
  .text_wrap_right {
    width: 20px;
    text-align: end;
    margin: auto 0;
  }
`

const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const DivideWrap = styled.div`
  padding: 16px 0;
`
